export default class Model {
    id: number;
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Model.ts